import { Controller } from "react-hook-form";
import { Stack, Group } from "@mantine/core";
import { Checkbox } from "@onengine/component-library";
import { FormErrorBox } from "@/components/ui/FormErrorBox/FormErrorBox";
import { OtherTextInput } from "./OtherTextInput";
import type { ControlledFieldProps } from "./types";

const OTHER_VALUE = "__other__";

export function ControlledCheckbox({
  name,
  control,
  error,
  clearErrors,
  options,
  allowOther,
}: ControlledFieldProps & { options: { label: string; value: string }[]; allowOther?: boolean }) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      render={({ field }) => {
        const selected: string[] = Array.isArray(field.value) ? field.value : [];
        const isOtherChecked = selected.includes(OTHER_VALUE);
        return (
          <Stack gap="xs">
            <Checkbox
              options={allowOther ? options.filter((o) => o.label !== "Other") : options}
              selectedValues={selected.filter((v) => v !== OTHER_VALUE)}
              onValuesChange={(val) => {
                field.onChange(isOtherChecked ? [...val, OTHER_VALUE] : val);
                clearErrors(name);
              }}
              size="small"
            />
            {error && <FormErrorBox message={error} />}
            {allowOther && (
              <Group gap="sm" align="flex-start" wrap="nowrap">
                <Checkbox
                  label="Other"
                  size="small"
                  state={isOtherChecked ? "selected" : "deselected"}
                  onValueChange={(checked) => {
                    const next = checked
                      ? [...selected, OTHER_VALUE]
                      : selected.filter((v) => v !== OTHER_VALUE);
                    field.onChange(next);
                    clearErrors(name);
                  }}
                />
                <OtherTextInput
                  name={`${name}__other`}
                  control={control}
                  disabled={!isOtherChecked}
                />
              </Group>
            )}
          </Stack>
        );
      }}
    />
  );
}
